import { Button, Form, Input, Modal, Select } from "antd";
import React from "react";

const { Option } = Select;

function SwitchUnitPlansModal(props) {
  const onFinish = (values) => {
    console.log("Success:", values);
    props.handleCancel();
  };
  return (
    <Modal
      title={"Change unit"}
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={props.handleCancel}
      footer={null}
    >
      <Form
        name="basic"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
      >
        <Form.Item label="Org level" name="level">
          <Select defaultValue={"all"} placeholder="Select org level">
            <Option value="all">All</Option>
            <Option value="group">Group</Option>
            <Option value="company">Company</Option>
            <Option value="department">Department</Option>
            <Option value="division">Division</Option>
          </Select>
        </Form.Item>

        <Form.Item label="Unit name" name="unitName">
          <Input placeholder="Unit name" />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3" onClick={props.handleCancel}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              Change unit
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default SwitchUnitPlansModal;
